'use client';

import { Spinner } from '@heroui/react';

/**
 * Shown in place of the app while a tab's stored View-as session is verified
 * by the server on a full page load (M4S-5670 §4 step 2). Nothing renders as
 * the staff member in a tab that is meant to be the client's.
 *
 * `quiet` is the moment before the tab has looked for a stored session: a
 * plain spinner, the same on the server and in the browser's first render.
 */
export function ViewAsRestoring({ quiet = false }: { quiet?: boolean }) {
    return (
        <div
            className="flex h-screen flex-col items-center justify-center gap-3 text-small text-default-500"
            role="status"
            aria-live="polite"
        >
            <Spinner size="md" />
            {quiet ? null : <span>Restoring View as…</span>}
        </div>
    );
}
